import { render, staticRenderFns } from "./template.vue?vue&type=template&id=0b451fcd"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=0b451fcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports